import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from '@nerdwallet/base-styles/classes';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { Title, Body } from '@nerdwallet/react-typography';
import Image from '@nerdwallet/react-image';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';
import { CenteredContainer } from '@nerdwallet/react-layout';

const Security = ({ imageSrc, securityHeader, securityText }) => (
  <BedrockImpression entityName="acct_security_container">
    <ElementImpression
      elementDomType="section"
      elementName="Security"
      id="security-container"
    >
      <CenteredContainer
        className={classNames([
          'security__section',
          classes('padding-vertical-4'),
          classes('margin-bottom-5'),
          classes('padding-horizontal-4--wide'),
        ])}
      >
        <div className="security__image-wrapper">
          <div className="security__image-cont">
            <Image
              src={imageSrc}
              alt=""
              naturalWidth={50}
              naturalHeight={71}
              backgroundColor="transparent"
              imageClassName={classNames([
                'security__image',
                classes('margin-top-2--wide'),
                classes('margin-bottom-3'),
                classes('margin-vertical-0'),
                classes('align-items-center--wide'),
              ])}
            />
          </div>
        </div>
        <div
          className={classNames([
            'security__content-inner',
            classes('display-flex--wide'),
            classes('flex-direction-column--wide'),
          ])}
        >
          <Title
            size="large"
            className={classNames([
              'security-section__header',
              classes('text-align-left--wide'),
              classes('padding-bottom-3'),
            ])}
          >
            {securityHeader}
          </Title>
          <Body
            className={classNames([
              'security-section__text',
              classes('text-align-left--wide'),
            ])}
          >
            {securityText}
          </Body>
        </div>
      </CenteredContainer>
    </ElementImpression>
  </BedrockImpression>
);

Security.propTypes = {
  imageSrc: PropTypes.string,
  securityHeader: PropTypes.string,
  securityText: PropTypes.node,
};

Security.displayName = 'Security';

export default Security;
